import type { UiLogoVariant } from './UiLogo.types';

export const LOGO_MAP: Record<UiLogoVariant, string> = {
    emblem: '/logos/haustein-logo-emblem.svg',
    wordmark: '/logos/haustein-logo-wordmark.svg',
    full: '/logos/haustein-logo-full.svg',
    footer: '/logos/haustein-logo-footer.svg',
    background: '/logos/haustein-logo-background.svg',
};
